import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

/**
 * App Component
 * Entry point for the portfolio application providing essential context providers,
 * routing setup, and the global layout wrapper.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />
              {/* 
                Catch-all for potential 404s in a single-page setup 
                Redirects back to home to maintain the SPA experience
              */}
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        
        {/* Global UI Components for notifications and feedback */}
        <Toaster />
        <Sonner 
          position="bottom-right" 
          closeButton 
          richColors 
          expand={false}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;